// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetPrototypeModulesListRequestModel from '../../model/get-prototype-modules-list-request-model';
import GetPrototypeModulesListRequestDTO from '../dto/get-prototype-modules-list-request-dto';
import dtoSchema from '../schemas/get-prototype-modules-list-request-schema';

export default abstract class GetPrototypeModulesListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetPrototypeModulesListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.year = data.year;
      this.classId = data.classId;
      this.classIds = data.classIds;
      this.moduleId = data.moduleId;
      this.lectureLessonStatusId = data.lectureLessonStatusId;
      this.userId = data.userId;
      this.lecturerId = data.lecturerId;
      this.primaryLeadLecturerId = data.primaryLeadLecturerId;
      this.isPrototype = data.isPrototype;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int32}
  */
  year?: number;
  /**
  * @type {int64}
  */
  classId?: number;
  /**
  */
  classIds?: number[];
  /**
  * @type {int64}
  */
  moduleId?: number;
  /**
  * @type {int64}
  */
  lectureLessonStatusId?: number;
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {int64}
  */
  lecturerId?: number;
  /**
  * @type {int64}
  */
  primaryLeadLecturerId?: number;
  /**
  */
  isPrototype?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetPrototypeModulesListRequestDTO>): GetPrototypeModulesListRequestModel;
  static toModel(dto: DeepPartial<GetPrototypeModulesListRequestDTO> | undefined | null): GetPrototypeModulesListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetPrototypeModulesListRequestDTO> | undefined | null): GetPrototypeModulesListRequestModel | undefined {
    return dto ? new GetPrototypeModulesListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetPrototypeModulesListRequestModel> | GetPrototypeModulesListRequestModel): GetPrototypeModulesListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      year: unwrapped.year,
      classId: unwrapped.classId,
      classIds: unwrapped.classIds,
      moduleId: unwrapped.moduleId,
      lectureLessonStatusId: unwrapped.lectureLessonStatusId,
      userId: unwrapped.userId,
      lecturerId: unwrapped.lecturerId,
      primaryLeadLecturerId: unwrapped.primaryLeadLecturerId,
      isPrototype: unwrapped.isPrototype,
      searchCriteria: unwrapped.searchCriteria,
    } as GetPrototypeModulesListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetPrototypeModulesListRequestModel, can not map to GetPrototypeModulesListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
